import React from 'react';
import { DashboardProvider } from './contexts/DashboardContext';
import { AuthProvider } from './contexts/AuthContext';
import DashboardLayout from './components/layout/DashboardLayout';

function App() {
  return (
    <AuthProvider>
      <DashboardProvider>
        {/* h-dvh, а не h-screen: на мобильных 100vh включает адресную строку,
            из-за чего нижние элементы уезжают за пределы экрана */}
        <div className="h-dvh">
          <DashboardLayout />
        </div>
      </DashboardProvider>
    </AuthProvider>
  );
}

export default App;
